module.exports = __webpack_public_path__ + "21215942651a360380559104dd409c4c.svg";